module.exports = __webpack_public_path__ + "static/index/img/baikal-507.a725909c.jpg";